<svg width="308" height="154" viewBox="0 0 308 154" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path d="M17.9236 73.4538L15.7794 75.598L17.9236 77.7422L20.0678 75.598L17.9236 73.4538Z" fill="url(#paint0_linear_6014_2445)"/>
<path d="M33.0432 88.3466L30.6722 90.7176L33.0432 93.0886L35.4142 90.7176L33.0432 88.3466Z" fill="url(#paint1_linear_6014_2445)"/>
<path d="M48.1628 103.26L45.5856 105.837L48.1628 108.414L50.74 105.837L48.1628 103.26Z" fill="url(#paint2_linear_6014_2445)"/>
<path d="M63.2824 118.586L60.9114 120.957L63.2824 123.328L65.6534 120.957L63.2824 118.586Z" fill="url(#paint3_linear_6014_2445)"/>
<path d="M78.402 133.932L76.2578 136.076L78.402 138.221L80.5462 136.076L78.402 133.932Z" fill="url(#paint4_linear_6014_2445)"/>
<path d="M2.804 27.662L0.226793 30.2392L2.804 32.8164L5.3812 30.2392L2.804 27.662Z" fill="url(#paint5_linear_6014_2445)"/>
<path d="M17.9236 42.328L14.8928 45.3588L17.9236 48.3896L20.9544 45.3588L17.9236 42.328Z" fill="url(#paint6_linear_6014_2445)"/>
<path d="M33.0432 57.0146L29.5794 60.4784L33.0432 63.9421L36.507 60.4784L33.0432 57.0146Z" fill="url(#paint7_linear_6014_2445)"/>
<path d="M48.1628 71.7012L44.2661 75.598L48.1628 79.4947L52.0595 75.598L48.1628 71.7012Z" fill="url(#paint8_linear_6014_2445)"/>
<path d="M63.2824 86.3673L58.9321 90.7176L63.2824 95.0679L67.6327 90.7176L63.2824 86.3673Z" fill="url(#paint9_linear_6014_2445)"/>
<path d="M78.402 101.94L74.5053 105.837L78.402 109.734L82.2987 105.837L78.402 101.94Z" fill="url(#paint10_linear_6014_2445)"/>
<path d="M93.5216 117.493L90.0578 120.957L93.5216 124.421L96.9854 120.957L93.5216 117.493Z" fill="url(#paint11_linear_6014_2445)"/>
<path d="M108.641 133.046L105.61 136.076L108.641 139.107L111.672 136.076L108.641 133.046Z" fill="url(#paint12_linear_6014_2445)"/>
<path d="M123.761 148.619L121.184 151.196L123.761 153.773L126.338 151.196L123.761 148.619Z" fill="url(#paint13_linear_6014_2445)"/>
<path d="M2.804 -2.804L0 0L2.804 2.804L5.608 0L2.804 -2.804Z" fill="url(#paint14_linear_6014_2445)"/>
<path d="M17.9236 11.6558L14.4598 15.1196L17.9236 18.5834L21.3874 15.1196L17.9236 11.6558Z" fill="url(#paint15_linear_6014_2445)"/>
<path d="M33.0432 26.1157L28.9197 30.2392L33.0432 34.3627L37.1667 30.2392L33.0432 26.1157Z" fill="url(#paint16_linear_6014_2445)"/>
<path d="M48.1628 40.5755L43.3795 45.3588L48.1628 50.1421L52.9461 45.3588L48.1628 40.5755Z" fill="url(#paint17_linear_6014_2445)"/>
<path d="M63.2824 55.0354L57.8393 60.4784L63.2824 65.9214L68.7254 60.4784L63.2824 55.0354Z" fill="url(#paint18_linear_6014_2445)"/>
<path d="M78.402 69.4952L72.2992 75.598L78.402 81.7008L84.5048 75.598L78.402 69.4952Z" fill="url(#paint19_linear_6014_2445)"/>
<path d="M93.5216 85.2745L88.0785 90.7176L93.5216 96.1606L98.9646 90.7176L93.5216 85.2745Z" fill="url(#paint20_linear_6014_2445)"/>
<path d="M108.641 101.054L103.858 105.837L108.641 110.62L113.424 105.837L108.641 101.054Z" fill="url(#paint21_linear_6014_2445)"/>
<path d="M123.761 116.833L119.637 120.957L123.761 125.08L127.884 120.957L123.761 116.833Z" fill="url(#paint22_linear_6014_2445)"/>
<path d="M138.88 132.613L135.417 136.076L138.88 139.54L142.344 136.076L138.88 132.613Z" fill="url(#paint23_linear_6014_2445)"/>
<path d="M154 148.392L151.196 151.196L154 154L156.804 151.196L154 148.392Z" fill="url(#paint24_linear_6014_2445)"/>
<path d="M2.804 -32.8164L0.226793 -30.2392L2.804 -27.662L5.3812 -30.2392L2.804 -32.8164Z" fill="url(#paint25_linear_6014_2445)"/>
<path d="M17.9236 -18.5834L14.4598 -15.1196L17.9236 -11.6558L21.3874 -15.1196L17.9236 -18.5834Z" fill="url(#paint26_linear_6014_2445)"/>
<path d="M33.0432 -4.35034L28.6929 0L33.0432 4.35031L37.3935 0L33.0432 -4.35034Z" fill="url(#paint27_linear_6014_2445)"/>
<path d="M48.1628 9.90334L42.9465 15.1196L48.1628 20.3358L53.3791 15.1196L48.1628 9.90334Z" fill="url(#paint28_linear_6014_2445)"/>
<path d="M63.2824 24.1364L57.1796 30.2392L63.2824 36.342L69.3852 30.2392L63.2824 24.1364Z" fill="url(#paint29_linear_6014_2445)"/>
<path d="M78.402 38.3694L71.4126 45.3588L78.402 52.3482L85.3914 45.3588L78.402 38.3694Z" fill="url(#paint30_linear_6014_2445)"/>
<path d="M93.5216 52.6231L85.6663 60.4784L93.5216 68.3337L101.377 60.4784L93.5216 52.6231Z" fill="url(#paint31_linear_6014_2445)"/>
<path d="M108.641 68.6086L101.652 75.598L108.641 82.5874L115.631 75.598L108.641 68.6086Z" fill="url(#paint32_linear_6014_2445)"/>
<path d="M123.761 84.6148L117.658 90.7176L123.761 96.8204L129.864 90.7176L123.761 84.6148Z" fill="url(#paint33_linear_6014_2445)"/>
<path d="M138.88 100.621L133.664 105.837L138.88 111.053L144.097 105.837L138.88 100.621Z" fill="url(#paint34_linear_6014_2445)"/>
<path d="M154 116.607L149.65 120.957L154 125.307L158.35 120.957L154 116.607Z" fill="url(#paint35_linear_6014_2445)"/>
<path d="M169.12 132.613L165.656 136.076L169.12 139.54L172.583 136.076L169.12 132.613Z" fill="url(#paint36_linear_6014_2445)"/>
<path d="M184.239 148.619L181.662 151.196L184.239 153.773L186.816 151.196L184.239 148.619Z" fill="url(#paint37_linear_6014_2445)"/>
<path d="M17.9236 -48.3896L14.8928 -45.3588L17.9236 -42.328L20.9544 -45.3588L17.9236 -48.3896Z" fill="url(#paint38_linear_6014_2445)"/>
<path d="M33.0432 -34.3627L28.9197 -30.2392L33.0432 -26.1157L37.1667 -30.2392L33.0432 -34.3627Z" fill="url(#paint39_linear_6014_2445)"/>
<path d="M48.1628 -20.3359L42.9465 -15.1196L48.1628 -9.90334L53.3791 -15.1196L48.1628 -20.3359Z" fill="url(#paint40_linear_6014_2445)"/>
<path d="M63.2824 -6.32962L56.9528 0L63.2824 6.32961L69.612 0L63.2824 -6.32962Z" fill="url(#paint41_linear_6014_2445)"/>
<path d="M78.402 7.69724L70.9796 15.1196L78.402 22.5419L85.8243 15.1196L78.402 7.69724Z" fill="url(#paint42_linear_6014_2445)"/>
<path d="M93.5216 21.7241L85.0065 30.2392L93.5216 38.7543L102.037 30.2392L93.5216 21.7241Z" fill="url(#paint43_linear_6014_2445)"/>
<path d="M108.641 35.7304L99.0128 45.3588L108.641 54.9872L118.27 45.3588L108.641 35.7304Z" fill="url(#paint44_linear_6014_2445)"/>
<path d="M123.761 51.9633L115.246 60.4784L123.761 68.9935L132.276 60.4784L123.761 51.9633Z" fill="url(#paint45_linear_6014_2445)"/>
<path d="M138.88 68.1757L131.458 75.598L138.88 83.0203L146.303 75.598L138.88 68.1757Z" fill="url(#paint46_linear_6014_2445)"/>
<path d="M154 84.388L147.67 90.7176L154 97.0472L160.33 90.7176L154 84.388Z" fill="url(#paint47_linear_6014_2445)"/>
<path d="M169.12 100.621L163.903 105.837L169.12 111.053L174.336 105.837L169.12 100.621Z" fill="url(#paint48_linear_6014_2445)"/>
<path d="M184.239 116.833L180.116 120.957L184.239 125.08L188.363 120.957L184.239 116.833Z" fill="url(#paint49_linear_6014_2445)"/>
<path d="M199.359 133.046L196.328 136.076L199.359 139.107L202.39 136.076L199.359 133.046Z" fill="url(#paint50_linear_6014_2445)"/>
<path d="M17.9236 -77.7422L15.7794 -75.598L17.9236 -73.4538L20.0678 -75.598L17.9236 -77.7422Z" fill="url(#paint51_linear_6014_2445)"/>
<path d="M33.0432 -63.9422L29.5794 -60.4784L33.0432 -57.0146L36.507 -60.4784L33.0432 -63.9422Z" fill="url(#paint52_linear_6014_2445)"/>
<path d="M48.1628 -50.1421L43.3795 -45.3588L48.1628 -40.5755L52.9461 -45.3588L48.1628 -50.1421Z" fill="url(#paint53_linear_6014_2445)"/>
<path d="M63.2824 -36.342L57.1796 -30.2392L63.2824 -24.1364L69.3852 -30.2392L63.2824 -36.342Z" fill="url(#paint54_linear_6014_2445)"/>
<path d="M78.402 -22.5419L70.9796 -15.1196L78.402 -7.69727L85.8243 -15.1196L78.402 -22.5419Z" fill="url(#paint55_linear_6014_2445)"/>
<path d="M93.5216 -8.74188L84.7797 0L93.5216 8.74187L102.263 0L93.5216 -8.74188Z" fill="url(#paint56_linear_6014_2445)"/>
<path d="M108.641 5.05818L98.5798 15.1196L108.641 25.181L118.703 15.1196L108.641 5.05818Z" fill="url(#paint57_linear_6014_2445)"/>
<path d="M123.761 18.8583L112.38 30.2392L123.761 41.6201L135.142 30.2392L123.761 18.8583Z" fill="url(#paint58_linear_6014_2445)"/>
<path d="M138.88 35.2974L128.819 45.3588L138.88 55.4202L148.942 45.3588L138.88 35.2974Z" fill="url(#paint59_linear_6014_2445)"/>
<path d="M154 51.7365L145.258 60.4784L154 69.2203L162.742 60.4784L154 51.7365Z" fill="url(#paint60_linear_6014_2445)"/>
<path d="M169.12 68.1756L161.697 75.598L169.12 83.0204L176.542 75.598L169.12 68.1756Z" fill="url(#paint61_linear_6014_2445)"/>
<path d="M184.239 84.6148L178.136 90.7176L184.239 96.8204L190.342 90.7176L184.239 84.6148Z" fill="url(#paint62_linear_6014_2445)"/>
<path d="M199.359 101.054L194.576 105.837L199.359 110.62L204.142 105.837L199.359 101.054Z" fill="url(#paint63_linear_6014_2445)"/>
<path d="M214.478 117.493L211.015 120.957L214.478 124.421L217.942 120.957L214.478 117.493Z" fill="url(#paint64_linear_6014_2445)"/>
<path d="M229.598 133.932L227.454 136.076L229.598 138.221L231.742 136.076L229.598 133.932Z" fill="url(#paint65_linear_6014_2445)"/>
<path d="M33.0432 -93.0886L30.6722 -90.7176L33.0432 -88.3466L35.4142 -90.7176L33.0432 -93.0886Z" fill="url(#paint66_linear_6014_2445)"/>
<path d="M48.1628 -79.4947L44.2661 -75.598L48.1628 -71.7013L52.0595 -75.598L48.1628 -79.4947Z" fill="url(#paint67_linear_6014_2445)"/>
<path d="M63.2824 -65.9215L57.8393 -60.4784L63.2824 -55.0353L68.7254 -60.4784L63.2824 -65.9215Z" fill="url(#paint68_linear_6014_2445)"/>
<path d="M78.402 -52.3482L71.4126 -45.3588L78.402 -38.3694L85.3914 -45.3588L78.402 -52.3482Z" fill="url(#paint69_linear_6014_2445)"/>
<path d="M93.5216 -38.7543L85.0065 -30.2392L93.5216 -21.7241L102.037 -30.2392L93.5216 -38.7543Z" fill="url(#paint70_linear_6014_2445)"/>
<path d="M108.641 -25.181L98.5798 -15.1196L108.641 -5.0582L118.703 -15.1196L108.641 -25.181Z" fill="url(#paint71_linear_6014_2445)"/>
<path d="M123.761 -11.6077L112.153 0L123.761 11.6077L135.369 0L123.761 -11.6077Z" fill="url(#paint72_linear_6014_2445)"/>
<path d="M138.88 1.98616L125.747 15.1196L138.88 28.253L152.014 15.1196L138.88 1.98616Z" fill="url(#paint73_linear_6014_2445)"/>
<path d="M154 18.6315L142.392 30.2392L154 41.8469L165.608 30.2392L154 18.6315Z" fill="url(#paint74_linear_6014_2445)"/>
<path d="M169.12 35.2974L159.058 45.3588L169.12 55.4202L179.181 45.3588L169.12 35.2974Z" fill="url(#paint75_linear_6014_2445)"/>
<path d="M184.239 51.9633L175.724 60.4784L184.239 68.9935L192.754 60.4784L184.239 51.9633Z" fill="url(#paint76_linear_6014_2445)"/>
<path d="M199.359 68.6086L192.369 75.598L199.359 82.5874L206.348 75.598L199.359 68.6086Z" fill="url(#paint77_linear_6014_2445)"/>
<path d="M214.478 85.2745L209.035 90.7176L214.478 96.1607L219.921 90.7176L214.478 85.2745Z" fill="url(#paint78_linear_6014_2445)"/>
<path d="M229.598 101.94L225.701 105.837L229.598 109.734L233.495 105.837L229.598 101.94Z" fill="url(#paint79_linear_6014_2445)"/>
<path d="M244.718 118.586L242.347 120.957L244.718 123.328L247.089 120.957L244.718 118.586Z" fill="url(#paint80_linear_6014_2445)"/>
<path d="M48.1628 -108.414L45.5856 -105.837L48.1628 -103.26L50.74 -105.837L48.1628 -108.414Z" fill="url(#paint81_linear_6014_2445)"/>
<path d="M63.2824 -95.0679L58.9321 -90.7176L63.2824 -86.3673L67.6327 -90.7176L63.2824 -95.0679Z" fill="url(#paint82_linear_6014_2445)"/>
<path d="M78.402 -81.7008L72.2992 -75.598L78.402 -69.4952L84.5048 -75.598L78.402 -81.7008Z" fill="url(#paint83_linear_6014_2445)"/>
<path d="M93.5216 -68.3337L85.6663 -60.4784L93.5216 -52.6231L101.377 -60.4784L93.5216 -68.3337Z" fill="url(#paint84_linear_6014_2445)"/>
<path d="M108.641 -54.9872L99.0128 -45.3588L108.641 -35.7304L118.27 -45.3588L108.641 -54.9872Z" fill="url(#paint85_linear_6014_2445)"/>
<path d="M123.761 -41.6201L112.38 -30.2392L123.761 -18.8583L135.142 -30.2392L123.761 -41.6201Z" fill="url(#paint86_linear_6014_2445)"/>
<path d="M138.88 -28.253L125.747 -15.1196L138.88 -1.98618L152.014 -15.1196L138.88 -28.253Z" fill="url(#paint87_linear_6014_2445)"/>
<path d="M154 -14.9066L139.093 0L154 14.9066L168.907 0L154 -14.9066Z" fill="url(#paint88_linear_6014_2445)"/>
<path d="M169.12 1.98616L155.986 15.1196L169.12 28.253L182.253 15.1196L169.12 1.98616Z" fill="url(#paint89_linear_6014_2445)"/>
<path d="M184.239 18.8583L172.858 30.2392L184.239 41.6201L195.62 30.2392L184.239 18.8583Z" fill="url(#paint90_linear_6014_2445)"/>
<path d="M199.359 35.7304L189.73 45.3588L199.359 54.9872L208.987 45.3588L199.359 35.7304Z" fill="url(#paint91_linear_6014_2445)"/>
<path d="M214.478 52.6231L206.623 60.4784L214.478 68.3337L222.334 60.4784L214.478 52.6231Z" fill="url(#paint92_linear_6014_2445)"/>
<path d="M229.598 69.4952L223.495 75.598L229.598 81.7008L235.701 75.598L229.598 69.4952Z" fill="url(#paint93_linear_6014_2445)"/>
<path d="M244.718 86.3673L240.367 90.7176L244.718 95.0679L249.068 90.7176L244.718 86.3673Z" fill="url(#paint94_linear_6014_2445)"/>
<path d="M259.837 103.26L257.26 105.837L259.837 108.414L262.414 105.837L259.837 103.26Z" fill="url(#paint95_linear_6014_2445)"/>
<path d="M63.2824 -123.328L60.9114 -120.957L63.2824 -118.586L65.6534 -120.957L63.2824 -123.328Z" fill="url(#paint96_linear_6014_2445)"/>
<path d="M78.402 -109.734L74.5053 -105.837L78.402 -101.94L82.2987 -105.837L78.402 -109.734Z" fill="url(#paint97_linear_6014_2445)"/>
<path d="M93.5216 -96.1607L88.0785 -90.7176L93.5216 -85.2746L98.9646 -90.7176L93.5216 -96.1607Z" fill="url(#paint98_linear_6014_2445)"/>
<path d="M108.641 -82.5874L101.652 -75.598L108.641 -68.6086L115.631 -75.598L108.641 -82.5874Z" fill="url(#paint99_linear_6014_2445)"/>
<path d="M123.761 -68.9935L115.246 -60.4784L123.761 -51.9633L132.276 -60.4784L123.761 -68.9935Z" fill="url(#paint100_linear_6014_2445)"/>
<path d="M138.88 -55.4202L128.819 -45.3588L138.88 -35.2974L148.942 -45.3588L138.88 -55.4202Z" fill="url(#paint101_linear_6014_2445)"/>
<path d="M154 -41.8469L142.392 -30.2392L154 -18.6315L165.608 -30.2392L154 -41.8469Z" fill="url(#paint102_linear_6014_2445)"/>
<path d="M169.12 -28.253L155.986 -15.1196L169.12 -1.98618L182.253 -15.1196L169.12 -28.253Z" fill="url(#paint103_linear_6014_2445)"/>
<path d="M184.239 -11.6077L172.631 0L184.239 11.6077L195.847 0L184.239 -11.6077Z" fill="url(#paint104_linear_6014_2445)"/>
<path d="M199.359 5.05821L189.297 15.1196L199.359 25.181L209.42 15.1196L199.359 5.05821Z" fill="url(#paint105_linear_6014_2445)"/>
<path d="M214.478 21.7241L205.963 30.2392L214.478 38.7543L222.993 30.2392L214.478 21.7241Z" fill="url(#paint106_linear_6014_2445)"/>
<path d="M229.598 38.3694L222.609 45.3588L229.598 52.3482L236.587 45.3588L229.598 38.3694Z" fill="url(#paint107_linear_6014_2445)"/>
<path d="M244.718 55.0354L239.275 60.4784L244.718 65.9214L250.161 60.4784L244.718 55.0354Z" fill="url(#paint108_linear_6014_2445)"/>
<path d="M259.837 71.7013L255.94 75.598L259.837 79.4947L263.734 75.598L259.837 71.7013Z" fill="url(#paint109_linear_6014_2445)"/>
<path d="M274.957 88.3466L272.586 90.7176L274.957 93.0886L277.328 90.7176L274.957 88.3466Z" fill="url(#paint110_linear_6014_2445)"/>
<path d="M78.402 -138.221L76.2578 -136.076L78.402 -133.932L80.5462 -136.076L78.402 -138.221Z" fill="url(#paint111_linear_6014_2445)"/>
<path d="M93.5216 -124.421L90.0578 -120.957L93.5216 -117.493L96.9854 -120.957L93.5216 -124.421Z" fill="url(#paint112_linear_6014_2445)"/>
<path d="M108.641 -110.621L103.858 -105.837L108.641 -101.054L113.424 -105.837L108.641 -110.621Z" fill="url(#paint113_linear_6014_2445)"/>
<path d="M123.761 -96.8204L117.658 -90.7176L123.761 -84.6148L129.864 -90.7176L123.761 -96.8204Z" fill="url(#paint114_linear_6014_2445)"/>
<path d="M138.88 -83.0204L131.458 -75.598L138.88 -68.1757L146.303 -75.598L138.88 -83.0204Z" fill="url(#paint115_linear_6014_2445)"/>
<path d="M154 -69.2203L145.258 -60.4784L154 -51.7365L162.742 -60.4784L154 -69.2203Z" fill="url(#paint116_linear_6014_2445)"/>
<path d="M169.12 -55.4202L159.058 -45.3588L169.12 -35.2974L179.181 -45.3588L169.12 -55.4202Z" fill="url(#paint117_linear_6014_2445)"/>
<path d="M184.239 -41.6201L172.858 -30.2392L184.239 -18.8583L195.62 -30.2392L184.239 -41.6201Z" fill="url(#paint118_linear_6014_2445)"/>
<path d="M199.359 -25.181L189.297 -15.1196L199.359 -5.05823L209.42 -15.1196L199.359 -25.181Z" fill="url(#paint119_linear_6014_2445)"/>
<path d="M214.478 -8.74188L205.737 0L214.478 8.74185L223.22 0L214.478 -8.74188Z" fill="url(#paint120_linear_6014_2445)"/>
<path d="M229.598 7.69724L222.176 15.1196L229.598 22.5419L237.02 15.1196L229.598 7.69724Z" fill="url(#paint121_linear_6014_2445)"/>
<path d="M244.718 24.1364L238.615 30.2392L244.718 36.342L250.82 30.2392L244.718 24.1364Z" fill="url(#paint122_linear_6014_2445)"/>
<path d="M259.837 40.5755L255.054 45.3588L259.837 50.1421L264.62 45.3588L259.837 40.5755Z" fill="url(#paint123_linear_6014_2445)"/>
<path d="M274.957 57.0146L271.493 60.4784L274.957 63.9421L278.421 60.4784L274.957 57.0146Z" fill="url(#paint124_linear_6014_2445)"/>
<path d="M290.076 73.4538L287.932 75.598L290.076 77.7422L292.221 75.598L290.076 73.4538Z" fill="url(#paint125_linear_6014_2445)"/>
<path d="M108.641 -139.107L105.61 -136.076L108.641 -133.046L111.672 -136.076L108.641 -139.107Z" fill="url(#paint126_linear_6014_2445)"/>
<path d="M123.761 -125.08L119.637 -120.957L123.761 -116.833L127.884 -120.957L123.761 -125.08Z" fill="url(#paint127_linear_6014_2445)"/>
<path d="M138.88 -111.053L133.664 -105.837L138.88 -100.621L144.097 -105.837L138.88 -111.053Z" fill="url(#paint128_linear_6014_2445)"/>
<path d="M154 -97.0472L147.67 -90.7176L154 -84.388L160.33 -90.7176L154 -97.0472Z" fill="url(#paint129_linear_6014_2445)"/>
<path d="M169.12 -83.0204L161.697 -75.598L169.12 -68.1757L176.542 -75.598L169.12 -83.0204Z" fill="url(#paint130_linear_6014_2445)"/>
<path d="M184.239 -68.9935L175.724 -60.4784L184.239 -51.9633L192.754 -60.4784L184.239 -68.9935Z" fill="url(#paint131_linear_6014_2445)"/>
<path d="M199.359 -54.9872L189.73 -45.3588L199.359 -35.7304L208.987 -45.3588L199.359 -54.9872Z" fill="url(#paint132_linear_6014_2445)"/>
<path d="M214.478 -38.7543L205.963 -30.2392L214.478 -21.7241L222.993 -30.2392L214.478 -38.7543Z" fill="url(#paint133_linear_6014_2445)"/>
<path d="M229.598 -22.5419L222.176 -15.1196L229.598 -7.69725L237.02 -15.1196L229.598 -22.5419Z" fill="url(#paint134_linear_6014_2445)"/>
<path d="M244.718 -6.32964L238.388 0L244.718 6.32962L251.047 0L244.718 -6.32964Z" fill="url(#paint135_linear_6014_2445)"/>
<path d="M259.837 9.90335L254.621 15.1196L259.837 20.3358L265.053 15.1196L259.837 9.90335Z" fill="url(#paint136_linear_6014_2445)"/>
<path d="M274.957 26.1157L270.833 30.2392L274.957 34.3627L279.08 30.2392L274.957 26.1157Z" fill="url(#paint137_linear_6014_2445)"/>
<path d="M290.076 42.328L287.046 45.3588L290.076 48.3896L293.107 45.3588L290.076 42.328Z" fill="url(#paint138_linear_6014_2445)"/>
<path d="M123.761 -153.773L121.184 -151.196L123.761 -148.619L126.338 -151.196L123.761 -153.773Z" fill="url(#paint139_linear_6014_2445)"/>
<path d="M138.88 -139.54L135.417 -136.076L138.88 -132.613L142.344 -136.076L138.88 -139.54Z" fill="url(#paint140_linear_6014_2445)"/>
<path d="M154 -125.307L149.65 -120.957L154 -116.606L158.35 -120.957L154 -125.307Z" fill="url(#paint141_linear_6014_2445)"/>
<path d="M169.12 -111.053L163.903 -105.837L169.12 -100.621L174.336 -105.837L169.12 -111.053Z" fill="url(#paint142_linear_6014_2445)"/>
<path d="M184.239 -96.8204L178.136 -90.7176L184.239 -84.6148L190.342 -90.7176L184.239 -96.8204Z" fill="url(#paint143_linear_6014_2445)"/>
<path d="M199.359 -82.5874L192.369 -75.598L199.359 -68.6086L206.348 -75.598L199.359 -82.5874Z" fill="url(#paint144_linear_6014_2445)"/>
<path d="M214.478 -68.3337L206.623 -60.4784L214.478 -52.6231L222.334 -60.4784L214.478 -68.3337Z" fill="url(#paint145_linear_6014_2445)"/>
<path d="M229.598 -52.3482L222.609 -45.3588L229.598 -38.3694L236.587 -45.3588L229.598 -52.3482Z" fill="url(#paint146_linear_6014_2445)"/>
<path d="M244.718 -36.342L238.615 -30.2392L244.718 -24.1364L250.82 -30.2392L244.718 -36.342Z" fill="url(#paint147_linear_6014_2445)"/>
<path d="M259.837 -20.3359L254.621 -15.1196L259.837 -9.90335L265.053 -15.1196L259.837 -20.3359Z" fill="url(#paint148_linear_6014_2445)"/>
<path d="M274.957 -4.35034L270.607 0L274.957 4.35031L279.307 0L274.957 -4.35034Z" fill="url(#paint149_linear_6014_2445)"/>
<path d="M290.076 11.6558L286.613 15.1196L290.076 18.5834L293.54 15.1196L290.076 11.6558Z" fill="url(#paint150_linear_6014_2445)"/>
<path d="M305.196 27.662L302.619 30.2392L305.196 32.8164L307.773 30.2392L305.196 27.662Z" fill="url(#paint151_linear_6014_2445)"/>
<path d="M154 -154L151.196 -151.196L154 -148.392L156.804 -151.196L154 -154Z" fill="url(#paint152_linear_6014_2445)"/>
<path d="M169.12 -139.54L165.656 -136.076L169.12 -132.613L172.583 -136.076L169.12 -139.54Z" fill="url(#paint153_linear_6014_2445)"/>
<path d="M184.239 -125.08L180.116 -120.957L184.239 -116.833L188.363 -120.957L184.239 -125.08Z" fill="url(#paint154_linear_6014_2445)"/>
<path d="M199.359 -110.621L194.576 -105.837L199.359 -101.054L204.142 -105.837L199.359 -110.621Z" fill="url(#paint155_linear_6014_2445)"/>
<path d="M214.478 -96.1607L209.035 -90.7176L214.478 -85.2746L219.921 -90.7176L214.478 -96.1607Z" fill="url(#paint156_linear_6014_2445)"/>
<path d="M229.598 -81.7008L223.495 -75.598L229.598 -69.4952L235.701 -75.598L229.598 -81.7008Z" fill="url(#paint157_linear_6014_2445)"/>
<path d="M244.718 -65.9215L239.275 -60.4784L244.718 -55.0354L250.161 -60.4784L244.718 -65.9215Z" fill="url(#paint158_linear_6014_2445)"/>
<path d="M259.837 -50.1421L255.054 -45.3588L259.837 -40.5755L264.62 -45.3588L259.837 -50.1421Z" fill="url(#paint159_linear_6014_2445)"/>
<path d="M274.957 -34.3627L270.833 -30.2392L274.957 -26.1157L279.08 -30.2392L274.957 -34.3627Z" fill="url(#paint160_linear_6014_2445)"/>
<path d="M290.076 -18.5834L286.613 -15.1196L290.076 -11.6559L293.54 -15.1196L290.076 -18.5834Z" fill="url(#paint161_linear_6014_2445)"/>
<path d="M305.196 -2.804L302.392 0L305.196 2.804L308 0L305.196 -2.804Z" fill="url(#paint162_linear_6014_2445)"/>
<path d="M184.239 -153.773L181.662 -151.196L184.239 -148.619L186.816 -151.196L184.239 -153.773Z" fill="url(#paint163_linear_6014_2445)"/>
<path d="M199.359 -139.107L196.328 -136.076L199.359 -133.046L202.39 -136.076L199.359 -139.107Z" fill="url(#paint164_linear_6014_2445)"/>
<path d="M214.478 -124.421L211.015 -120.957L214.478 -117.493L217.942 -120.957L214.478 -124.421Z" fill="url(#paint165_linear_6014_2445)"/>
<path d="M229.598 -109.734L225.701 -105.837L229.598 -101.94L233.495 -105.837L229.598 -109.734Z" fill="url(#paint166_linear_6014_2445)"/>
<path d="M244.718 -95.0679L240.367 -90.7176L244.718 -86.3673L249.068 -90.7176L244.718 -95.0679Z" fill="url(#paint167_linear_6014_2445)"/>
<path d="M259.837 -79.4948L255.94 -75.598L259.837 -71.7013L263.734 -75.598L259.837 -79.4948Z" fill="url(#paint168_linear_6014_2445)"/>
<path d="M274.957 -63.9422L271.493 -60.4784L274.957 -57.0146L278.421 -60.4784L274.957 -63.9422Z" fill="url(#paint169_linear_6014_2445)"/>
<path d="M290.076 -48.3896L287.046 -45.3588L290.076 -42.328L293.107 -45.3588L290.076 -48.3896Z" fill="url(#paint170_linear_6014_2445)"/>
<path d="M305.196 -32.8164L302.619 -30.2392L305.196 -27.662L307.773 -30.2392L305.196 -32.8164Z" fill="url(#paint171_linear_6014_2445)"/>
<path d="M229.598 -138.221L227.454 -136.076L229.598 -133.932L231.742 -136.076L229.598 -138.221Z" fill="url(#paint172_linear_6014_2445)"/>
<path d="M244.718 -123.328L242.347 -120.957L244.718 -118.586L247.089 -120.957L244.718 -123.328Z" fill="url(#paint173_linear_6014_2445)"/>
<path d="M259.837 -108.414L257.26 -105.837L259.837 -103.26L262.414 -105.837L259.837 -108.414Z" fill="url(#paint174_linear_6014_2445)"/>
<path d="M274.957 -93.0886L272.586 -90.7176L274.957 -88.3466L277.328 -90.7176L274.957 -93.0886Z" fill="url(#paint175_linear_6014_2445)"/>
<path d="M290.076 -77.7422L287.932 -75.598L290.076 -73.4538L292.221 -75.598L290.076 -77.7422Z" fill="url(#paint176_linear_6014_2445)"/>
</g>
<defs>
<linearGradient id="paint0_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint1_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint2_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint3_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint4_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint5_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint6_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint7_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint8_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint9_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint10_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint11_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint12_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint13_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint14_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint15_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint16_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint17_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint18_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint19_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint20_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint21_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint22_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint23_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint24_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint25_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint26_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint27_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint28_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint29_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint30_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint31_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint32_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint33_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint34_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint35_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint36_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint37_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint38_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint39_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint40_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint41_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint42_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint43_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint44_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint45_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint46_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint47_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint48_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint49_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint50_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint51_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint52_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint53_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint54_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint55_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint56_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint57_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint58_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint59_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint60_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint61_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint62_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint63_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint64_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint65_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint66_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint67_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint68_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint69_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint70_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint71_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint72_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint73_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint74_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint75_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint76_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint77_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint78_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint79_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint80_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint81_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint82_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint83_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint84_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint85_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint86_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint87_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint88_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint89_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint90_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint91_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint92_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint93_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint94_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint95_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint96_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint97_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint98_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint99_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint100_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint101_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint102_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint103_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint104_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint105_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint106_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint107_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint108_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint109_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint110_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint111_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint112_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint113_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint114_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint115_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint116_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint117_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint118_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint119_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint120_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint121_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint122_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint123_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint124_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint125_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint126_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint127_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint128_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint129_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint130_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint131_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint132_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint133_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint134_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint135_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint136_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint137_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint138_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint139_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint140_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint141_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint142_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint143_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint144_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint145_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint146_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint147_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint148_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint149_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint150_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint151_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint152_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint153_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint154_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint155_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint156_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint157_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint158_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint159_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint160_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint161_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint162_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint163_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint164_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint165_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint166_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint167_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint168_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint169_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint170_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint171_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint172_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint173_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint174_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint175_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint176_linear_6014_2445" x1="154" y1="61.2652" x2="154" y2="154" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
</defs>
</svg>
